var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Carrier_Payment_Outline",
    "data-name": "Carrier Payment Outline",
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(79 228)",
    fill: "#438afe",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Invoice",
    transform: "translate(80 230)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3248",
    "data-name": "Path 3248",
    d: "M18.083,13H17.25a.417.417,0,0,1-.417-.417.417.417,0,1,0-.833,0,1.25,1.25,0,0,0,1.25,1.25v.417a.417.417,0,1,0,.833,0v-.417a1.25,1.25,0,0,0,1.25-1.25v-.417a1.25,1.25,0,0,0-1.25-1.25H17.25a.417.417,0,0,1-.417-.417v-.417a.417.417,0,0,1,.417-.417h.833a.417.417,0,0,1,.417.417.417.417,0,1,0,.833,0,1.25,1.25,0,0,0-1.25-1.25V8.417a.417.417,0,1,0-.833,0v.417A1.25,1.25,0,0,0,16,10.083V10.5a1.25,1.25,0,0,0,1.25,1.25h.833a.417.417,0,0,1,.417.417v.417A.417.417,0,0,1,18.083,13Z",
    transform: "translate(-8.167 -4.667)",
    fill: "#438afe",
    stroke: "#438afe",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3249",
    "data-name": "Path 3249",
    d: "M17.583,35H8.417a.417.417,0,0,0,0,.833h9.167a.417.417,0,0,0,0-.833Z",
    transform: "translate(-3.5 -20.417)",
    fill: "#438afe",
    stroke: "#438afe",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3250",
    "data-name": "Path 3250",
    d: "M17.583,40H8.417a.417.417,0,0,0,0,.833h9.167a.417.417,0,0,0,0-.833Z",
    transform: "translate(-3.5 -23.333)",
    fill: "#438afe",
    stroke: "#438afe",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3251",
    "data-name": "Path 3251",
    d: "M17.583,30H8.417a.417.417,0,1,0,0,.833h9.167a.417.417,0,1,0,0-.833Z",
    transform: "translate(-3.5 -17.5)",
    fill: "#438afe",
    stroke: "#438afe",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3252",
    "data-name": "Path 3252",
    d: "M18.25,0H4.083A2.083,2.083,0,0,0,2,2.083v17.5A.417.417,0,0,0,2.417,20H16.583A.417.417,0,0,0,17,19.583V4.167h2.917a.417.417,0,0,0,.417-.417V2.083A2.083,2.083,0,0,0,18.25,0ZM16.167,19.167H2.833V2.083A1.25,1.25,0,0,1,4.083.833h12.5C16.017,1.6,16.167.546,16.167,19.167ZM19.5,3.333H17V2.083a1.25,1.25,0,1,1,2.5,0Z",
    transform: "translate(0)",
    fill: "#438afe",
    stroke: "#438afe",
    strokeWidth: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.8a4ab9addba8932254f36ececde2c585.svg";
export { ForwardRef as ReactComponent };